import { Component } from '@opten/compiler/metadata/component';
import { toggleClass } from '@opten/dom/toggle-class';

@Component({ className: 'js-form-newsletter' })
export class FormNewsletterComponent {
	newsletterListElement: HTMLSelectElement;
	newsletterListTopicsElements: HTMLElement[];

	constructor(private formElement: HTMLSelectElement) {
		var newsletterList = this.formElement.getElementsByClassName('js-form-newsletter-list');
		if (newsletterList && newsletterList.length > 0) {
			this.newsletterListElement = newsletterList[0] as HTMLSelectElement;
			var newsletterListTopicsElements = this.formElement.getElementsByClassName('js-form-newsletter-list-topics');
			if (newsletterListTopicsElements && newsletterListTopicsElements.length > 0) {
				this.newsletterListTopicsElements = (Array.from(newsletterListTopicsElements) as HTMLElement[]).filter(o => o.hasAttribute('data-list-id'));
				this.handleNewsletterListUpdated();
				this.newsletterListElement.addEventListener('change', () => this.handleNewsletterListUpdated());
			}
		}

	}
	handleNewsletterListUpdated(): any {
		const selectedList = this.newsletterListElement.value;
		this.newsletterListTopicsElements.forEach(element => toggleClass(element, 'd-none', (element.getAttribute('data-list-id') == selectedList) == false));
	}
}